import { inCommands } from '../../../concepts/commands/CommandRegistry';
import { inSessionProperties } from '../../canvas/EditorSession';
import { StateProperty } from '../../canvas/ExtendableStore';
import { inToolboxItems } from '../../canvas/tooling/ToolboxController';
import { inTool } from '../../canvas/tooling/ToolManager';
import { Package, PackageHost } from '../../Container';
import { inExportAdapter } from '../dataExport/ExportAdapter';
import { SelectedVoteRound } from './SelectedVoteRound';
import { VoteIndex } from './VoteIndex';
import { DefaultVoteRankingInfo, VoteRankingInfo } from './VoteRankingInfo';
import { castVote, clearVotes, createVoteRound, deleteVoteRound, revokeVote } from './VotingCommands';
import { VoteAggregateExportAdapter, VoteByParticipantExportAdapter } from './VotingExports';
import { VotingMechanics } from './VotingMechanics';
import { votingTool } from './VotingTool';
import { votingToolboxItem } from './VotingToolboxItem';

export class VotingPackage implements Package {

    public readonly name = 'VotingFeature';

    public install = (host: PackageHost) => host
        .register(VoteIndex, 'singleton')
        .register(VotingMechanics, 'singleton')
        .plug(inCommands(createVoteRound, deleteVoteRound, castVote, revokeVote, clearVotes))
        .plug(inExportAdapter(VoteAggregateExportAdapter))
        .plug(inExportAdapter(VoteByParticipantExportAdapter))
        .plug(inSessionProperties(
            StateProperty.variable(SelectedVoteRound, ''),
            StateProperty.variable(VoteRankingInfo, DefaultVoteRankingInfo()),
        ))
        .plug(inTool(votingTool))
        .plug(inToolboxItems(votingToolboxItem))
        .start(VoteIndex, VotingMechanics);
}
